<div class="di-wrap">

  <div class="di-toolbar">
    <p class="di-note">
      Problems reported by drivers from in front of the machine. Resolve when it is
      fixed or handed to a technician — the note travels into the record.
    </p>
    <div class="di-tabs">
      <button mat-stroked-button [class.di-tab-on]="tab === 'open'" (click)="setTab('open')">
        Open <span class="di-count" *ngIf="openCount">{{ openCount }}</span>
      </button>
      <button mat-stroked-button [class.di-tab-on]="tab === 'resolved'" (click)="setTab('resolved')">
        Resolved
      </button>
    </div>
  </div>

  <div class="di-empty" *ngIf="loading">Loading…</div>
  <div class="di-empty" *ngIf="!loading && !rows.length">
    {{ tab === 'open' ? 'Nothing open. Machines behaving.' : 'Nothing resolved yet.' }}
  </div>

  <div class="di-issue" *ngFor="let r of rows; trackBy: trackByIssue">
    <div class="di-head">
      <span class="di-system">{{ r.systemName }}</span>
      <span class="di-chip">{{ r.categoryLabel }}</span>
      <span class="di-when">{{ r.date }} {{ r.when }}</span>
    </div>
    <div class="di-note-text">{{ r.note }}</div>
    <div class="di-meta">Reported by {{ r.driverName }}</div>

    <div class="di-resolved" *ngIf="tab === 'resolved'">
      Resolved {{ r.resolvedWhen }} by {{ r.resolvedBy }}
      <span *ngIf="r.resolution"> — {{ r.resolution }}</span>
    </div>

    <div class="di-actions" *ngIf="tab === 'open'">
      <button mat-stroked-button (click)="startResolve(r)">
        {{ resolvingId === r.id ? 'Cancel' : 'Resolve' }}
      </button>
    </div>
    <div class="di-resolve-panel" *ngIf="tab === 'open' && resolvingId === r.id">
      <mat-form-field appearance="outline" class="di-resolution">
        <mat-label>What was done? (optional)</mat-label>
        <input matInput [(ngModel)]="resolutionNote" (keyup.enter)="confirmResolve(r)"
               placeholder="Technician booked for Thursday / restarted, working again">
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="confirmResolve(r)">Mark resolved</button>
    </div>

    <div class="di-actions" *ngIf="tab === 'resolved'">
      <button mat-button (click)="reopen(r)">Reopen</button>
    </div>
  </div>
</div>
